import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Heading } from 'components/Heading/Heading';
import { Section } from 'components/Section/Section';
import css from '../Search.scss';

export const reloadPage = () => {
  window.location.reload();
};

export const ErrorMessage = () => (
  <Section className={css.Search__results__error}>
    <Heading className="gamma mb mt-">
      <FormattedMessage id="search.results.error" defaultMessage="Sorry, something went wrong." />
    </Heading>
    <button className="bt bt--primary" onClick={reloadPage}>
      <FormattedMessage id="search.results.tryAgain" defaultMessage="Please try again." />
    </button>
  </Section>
);
